import axios from 'axios';
import { logout } from './auth';

// 强制使用本地代理，避免连接到生产服务器
// 开发环境必须使用相对路径 /api，通过 vue.config.js 代理到本地后端
let API_BASE_URL = '/api';

// 如果设置了环境变量，检查是否是生产服务器地址
if (process.env.VUE_APP_API_BASE_URL) {
  const envUrl = process.env.VUE_APP_API_BASE_URL;
  
  // 如果是生产服务器地址，强制使用本地代理并警告
  if (envUrl.startsWith('http://') || envUrl.startsWith('https://')) {
    const isProduction = !envUrl.includes('localhost') && !envUrl.includes('127.0.0.1');
    if (isProduction) {
      console.error('⚠️ 严重警告：检测到环境变量指向生产服务器！');
      console.error(`环境变量 VUE_APP_API_BASE_URL: ${envUrl}`);
      console.error('已强制使用本地代理 /api，避免影响生产环境');
      console.error('请删除或修改环境变量 VUE_APP_API_BASE_URL');
      // 强制使用本地代理
      API_BASE_URL = '/api';
    } else {
      // 本地地址，可以使用
      API_BASE_URL = envUrl;
    }
  } else {
    // 相对路径，可以使用
    API_BASE_URL = envUrl;
  }
}

// 创建axios实例
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求拦截器 - 添加认证令牌
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器 - 处理认证错误
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // 处理401未授权错误
    if (error.response && error.response.status === 401) {
      logout();
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;